<script>
  export let picture = '', name = '';

  let loading = true, error = false, pictureUrl = '';

  $: pictureUrl = `/images/users/${picture}`;
</script>

<div class="ProfilePicture">
  {#if !picture || error || loading}
    <div data-icon-before="person"></div>
  {/if}

  {#if picture && !error}
    <img src="{pictureUrl}"
         class:Loading={loading}
         alt="{name}"
         loading="lazy"
         on:error={() => error = true}
         on:load={() => loading = false}
    >
  {/if}
</div>

<style lang="stylus">

  .ProfilePicture {
    flex: 0 0 64px;
    height: 64px;
    width: 64px;
    border-radius 3px;
    border 1px solid #ECEFF1;
    background: #ECEFF1;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing border-box;
    text-align: center;
    overflow: hidden;

    img {
      object-fit: contain;
      font-size: 12px;
      height: 64px;
      width: 64px;

      &.Loading {
        width: 0;
        height: 0;
        visibility: hidden;
      }
    }

    div:before {
      font-size 50px;
    }
  }

</style>
